import classnames from "classnames";
import { filter, size } from "lodash";
import React, { Component } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import ReactLoading from "react-loading";
import { connect } from "react-redux";
import {
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row
} from "reactstrap";
import fullPatientImage from "../../files/full_input_patient.png";
import quickPatientImage from "../../files/quick_patient.png";
import usersImage from "../../files/users.png";
import CreateUserModal from "./CreateUserModal";
import CreateUserQuickModal from "./CreateUserQuickModal";
import Heading from "./Heading";
import ActivePatientList from "../Admin/AdminAnalytics/ActivePatientList";
import queryString from 'query-string';
import EducationMaterialSentPatients from "../EducationMaterialSentPatients";
import RpmCarePlanList from "../RpmCarePlanList";
import moment from "moment";
const _ = require("lodash");

const DashboardCard = ({ title, count, icon, color, onClick, isActive }) => (
  <div className={`dashboard-card ${isActive ? 'active' : ''}`} onClick={onClick}>
    <div className="dashboard-card-body">
      <div className={`left-border ${color}`} />
      <div className="card-content-area">
        <i className={`${icon} card-icon ${isActive ? 'active-icon' : ''}`} />
        <div className="card-text">
          <h5 style={{fontWeight : 900}}>{title}</h5>
          <h3>{count}</h3>
        </div>
      </div>
    </div>
  </div>
);

const MENU_API = {
  ALL_PATIENT: "AllPatient",
  ACTIVE_PATIENT: "Active",
  IN_ACTIVE_PATIENT: "InActive",
  DEMO_PATIENT: "Demo",
  CALLER_PATIENT: "Caller",
  NEED_TO_FOLLOW_UP: "NeedToFollowUp",
  FOLLOW_UP_REMINDERS : 'FollowUpReminder',
  REMINDER_SENT : 'ReminderSent',
  MONTHLY_CHECK_IN_PHONE_CALL : 'MonthlyCheckInPhoneCall',
  FOLLOW_UP_PHONE_CALL : 'FollowUpPhoneCall',
  EDUCATION_MATERIAL  : 'EducationMaterial',
  WARNING_ADHERENCE : 'WarningAdherence',
  NO_READING_UPLOADED : 'NoReadingUploaded',
  HOSPITAL_ADMISSION:"HospitalAdmission",
  WINS_POSITIVE_OUTCOME: 'WinsPositiveOutcome',
  RPM_CARE_PLAN: 'RpmCarePlan'
}
class Analytics extends Component {
  constructor(props) {
    super(props);

    this.props.dispatch({
      type: "DO_GET_USERS_LIST"
    });
    this.props.dispatch({
      type: "DO_GET_UNREAD_COUNT"
    });
    this.props.dispatch({
      type: "DO_GET_ASSIGNED_CAREPROVIDERS"
    });

    this.toggle = this.toggle.bind(this);
    this.state = {
      page: 1,
      limit: 10,
      activeTab: "1",
      modal: false,
      modal2: false,
      modalUser: false,
      modalQuickUser: false,
      emailOffer: "",
      emailAccess: "",
      fname: "",
      lname: "",
      nickname:"",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      gender: "Male",
      subOrganization: "",
      showAlertSuccess: false,
      errorPassword: false,
      conditions: [],
      insuranceProvider: "",
      enrolledPrograms: "",
      displayActiveList: true,
      loading: true,
      selectedApi: "Active",
      displayFollowUpReminderList : false,
      displayReminderSentList : false,
      displayfollowUpPhoneCall : false,
      displayMonthlyCheckInPhoneCall : false,
      displayEducationMaterialCard : false,
      educationPatientsCount : null,
      displayWarningAdherenceCard : null,
      displayNoReadingUploadedCard : null,
      displayHospitalAdmittedCard : null,
      displayWinsPositiveOutcome: false,
      displayRpmCarePlanList: false,

      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      hospitalPatientsCount : null
    };
    this.toggleUser = this.toggleUser.bind(this);
    this.toggleUserQuick = this.toggleUserQuick.bind(this);
    this.submitUser = this.submitUser.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputChangeCondition = this.handleInputChangeCondition.bind(this);
    this.resetForm = this.resetForm.bind(this);
    this.updateEducationCount = this.updateEducationCount.bind(this);
    this.updateCount = this.updateCount.bind(this);
    this.toggleWinsPositiveOutcomeList = this.toggleWinsPositiveOutcomeList.bind(this);
    this.toggleRpmCarePlanList = this.toggleRpmCarePlanList.bind(this);

  }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
    if (name === "confirmpassword") {
      const checkMatch = this.state.password === value;

      if (!checkMatch) {
        this.setState({ errorPassword: true });
      } else {
        this.setState({ errorPassword: false });
      }
    }
  }
  handleInputChangeCondition(e) {
    const conditions = _.map(e, "_id");
    this.setState({ conditions: conditions });
  }
  updateCount(event) {
    if (event) {
      this.setState({ hospitalPatientsCount: event })
    }
  }
  resetForm() {
    this.setState({
      modal2: false,
      modal: false,
      modalUser: false,
      modalQuickUser: false,
      fname: "",
      lname: "",
      nickname: "",
      username: "",
      email: "",
      phone: "",
      homeNumber: "",
      workNumber: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      weight: "",
      height: "",
      bday: "",
      memberId: "",
      organization: "",
      subOrganization: "",
      gender: "Male",
      role: "",
      conditions: []
    });
    this.props.dispatch({
      type: "GENERIC_ERROR"
    });
    this.props.dispatch({
      type: "DO_GET_USERS_LIST"
    });
    this.props.dispatch({
      type: "DO_GET_USERS_READING_UNDER_YOUR_ORGANIZATION"
    });
  }
  submitUser(e) {
    e.preventDefault();
    const cleanUser = _.omit(this.state, [
      "activeTab",
      "modal",
      "modal2",
      "modalUser",
      "modalQuickUser",
      "emailOffer",
      "confirmpassword",
      "emailAccess",
      "showAlertSuccess",
      "errorPassword",
      "displayActiveList",
      "loading",
      "page",
      "limit",
      "selectedApi",
      "displayWarningAdherenceCard"
    ]);
    this.props.dispatch({
      type: "DO_SAVE_USER",
      payload: cleanUser
    });
  }
  toggleUser() {
    this.setState({
      modalUser: !this.state.modalUser
    });
  }
  toggleUserQuick() {
    this.setState({
      modalQuickUser: !this.state.modalQuickUser
    });
  }
  toggleModal() {
    this.setState({
      modal: !this.state.modal
    });
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }
  toggleDisplayActiveList(display, loadData = true) {
    if (display) {
      //Display active list
      this.setState({ 
        displayActiveList: true,  
        selectedApi: MENU_API.ACTIVE_PATIENT,
        displayFollowUpReminderList: false, 
        displayReminderSentList: false, 
        displayfollowUpPhoneCall : false, 
        displayMonthlyCheckInPhoneCall :  false, 
        displayEducationMaterialCard : false, 
        displayWarningAdherenceCard : false, 
        displayNoReadingUploadedCard : false, 
        displayHospitalAdmittedCard : false,
        displayDemoList: null,
        displayCellularConnectivityList: false,
        displayNeedToFollowUpList: false,
        displayRpmCarePlanList: false,
        displayWinsPositiveOutcome: false
      }, () => {
        if(loadData){
          this.fetchData();
        }
      });
      this.setQueryParams({tab : MENU_API.ACTIVE_PATIENT})
    } else {
      // inactive list clicked
      this.setState({ 
        displayActiveList: false, 
        selectedApi: MENU_API.IN_ACTIVE_PATIENT,
        displayFollowUpReminderList: false, 
        displayReminderSentList: false, 
        displayfollowUpPhoneCall : false, 
        displayMonthlyCheckInPhoneCall :  false, 
        displayEducationMaterialCard : false, 
        displayWarningAdherenceCard : false, 
        displayNoReadingUploadedCard : false, 
        displayHospitalAdmittedCard : false,
        displayDemoList: null,
        displayCellularConnectivityList: false,
        displayNeedToFollowUpList: false,
        displayRpmCarePlanList: false,
        displayWinsPositiveOutcome: false
      }, () => {
        if(loadData){
          this.fetchData();
        }
      });
      this.setQueryParams({tab : MENU_API.IN_ACTIVE_PATIENT})
    }
  }
  
  toggleCellularConnectivityList(loadData = true) {
    this.setState({
      selectedApi: MENU_API.CALLER_PATIENT,
      displayCellularConnectivityList: true,
      displayNeedToFollowUpList: false,
      displayHospitalAdmittedCard: false,
      displayActiveList: null,
      displayDemoList: null,
      displayFollowUpReminderList: false,
      displayReminderSentList: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard: false,
      displayWarningAdherenceCard: false,
      displayNoReadingUploadedCard: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData) {
        this.fetchData();
      }
    });
    this.setQueryParams({tab: MENU_API.CALLER_PATIENT});
  }
  toggleWinsPositiveOutcomeList(loadData = true) {
    this.setState({
      selectedApi: MENU_API.WINS_POSITIVE_OUTCOME,
      displayWinsPositiveOutcome: true,
      displayRpmCarePlanList: false,
      displayActiveList: null,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAdmittedCard: false,
      displayFollowUpReminderList: false,
      displayReminderSentList: false,
      displayWarningAdherenceCard: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard: false,
      displayNoReadingUploadedCard: false
    }, () => {
      if(loadData){
        this.fetchData();
      }
    });
    this.setQueryParams({tab: MENU_API.WINS_POSITIVE_OUTCOME});
};
  toggleRpmCarePlanList() {
    this.setState({
      selectedApi: MENU_API.RPM_CARE_PLAN,
      displayRpmCarePlanList: true,
      displayWinsPositiveOutcome: false,
      displayActiveList: null,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayHospitalAdmittedCard: false,
      displayFollowUpReminderList: false,
      displayReminderSentList: false,
      displayWarningAdherenceCard: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard: false,
      displayNoReadingUploadedCard: false
    });
    this.setQueryParams({tab: MENU_API.RPM_CARE_PLAN});
  }
  toggleNeedToFollowUpList(loadData = true) {
    this.setState({
      selectedApi: MENU_API.NEED_TO_FOLLOW_UP,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: true,
      displayHospitalAdmittedCard: false,
      displayActiveList: null,
      displayDemoList: null,
      displayFollowUpReminderList: false,
      displayReminderSentList: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard: false,
      displayWarningAdherenceCard: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData) {
        this.fetchData();
      }
    });
    this.setQueryParams({tab: MENU_API.NEED_TO_FOLLOW_UP});
  }
  
  toggleDemoList(loadData = true) {
    this.setState({
      selectedApi: MENU_API.DEMO_PATIENT,
      displayDemoList: true,
      displayActiveList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayFollowUpReminderList: false,
      displayReminderSentList: false,
      displayfollowUpPhoneCall: false,
      displayMonthlyCheckInPhoneCall: false,
      displayEducationMaterialCard: false,
      displayWarningAdherenceCard: false,
      displayNoReadingUploadedCard: false,
      displayHospitalAdmittedCard: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData) {
        this.fetchData();
      }
    });
    this.setQueryParams({tab: MENU_API.DEMO_PATIENT});
  }
  toggleHospitalAdmittedPatientList(loadData = true){
    this.setState({
      displayActiveList: null,
      selectedApi: MENU_API.HOSPITAL_ADMISSION, 
      displayReminderSentList : false,
      displayFollowUpReminderList : false,
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false,
      displayWarningAdherenceCard : false,
      displayNoReadingUploadedCard : false,
      displayHospitalAdmittedCard : true,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData){
        this.fetchData();
      }
    });
    this.setQueryParams({tab : MENU_API.HOSPITAL_ADMISSION})
  }
  
  toggleAllPatients(loadData = true){
    this.setState({
      displayActiveList: null,
      selectedApi: MENU_API.ALL_PATIENT, 
      displayReminderSentList : false,
      displayFollowUpReminderList : false,
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  false,
      displayEducationMaterialCard : false,
      displayWarningAdherenceCard : false,
      displayNoReadingUploadedCard : false,
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData){
        this.fetchData();
      }
    });
    this.setQueryParams({tab : MENU_API.ALL_PATIENT})
  }
  toggleFollowUpReminders(loadData = true){
    this.setQueryParams({tab : MENU_API.FOLLOW_UP_REMINDERS});
    this.setState({ 
      displayFollowUpReminderList: true,
      displayReminderSentList: false,
      displayActiveList: null, 
      selectedApi: MENU_API.FOLLOW_UP_REMINDERS, 
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  false, 
      displayEducationMaterialCard : false, 
      displayWarningAdherenceCard : false, 
      displayNoReadingUploadedCard : false, 
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData){
        this.fetchData();
      }
    })
  }
  toggleRemindersSent(loadData = true){
    this.setQueryParams({tab : MENU_API.REMINDER_SENT});
    this.setState({ 
      displayReminderSentList: true,
      displayFollowUpReminderList: false,
      displayActiveList: null, 
      selectedApi: MENU_API.REMINDER_SENT, 
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  false, 
      displayEducationMaterialCard : false, 
      displayWarningAdherenceCard : false, 
      displayNoReadingUploadedCard : false, 
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData){
        this.fetchData();
      }
    })
  }
  toggleMonthlyCheckInPhoneCallList(loadData = true){
    this.setQueryParams({tab : MENU_API.MONTHLY_CHECK_IN_PHONE_CALL});
    this.setState({ 
      displayReminderSentList: false,
      displayFollowUpReminderList: false,
      displayActiveList: null, 
      selectedApi: MENU_API.MONTHLY_CHECK_IN_PHONE_CALL, 
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  true, 
      displayEducationMaterialCard : false, 
      displayWarningAdherenceCard : false, 
      displayNoReadingUploadedCard : false, 
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData){
        this.fetchData();
      }
    })
  }
  toggleFollowUpPhoneCallList(loadData = true){
    this.setQueryParams({tab : MENU_API.FOLLOW_UP_PHONE_CALL});
    this.setState({ 
      displayReminderSentList: false,
      displayFollowUpReminderList: false,
      displayActiveList: null, 
      selectedApi: MENU_API.FOLLOW_UP_PHONE_CALL, 
      displayfollowUpPhoneCall : true, 
      displayMonthlyCheckInPhoneCall :  false, 
      displayEducationMaterialCard : false, 
      displayWarningAdherenceCard : false, 
      displayNoReadingUploadedCard : false, 
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
      if(loadData){
        this.fetchData();
      }
    })
  }
  toggleEducationMaterialCard(loadData = true){
    this.setQueryParams({tab : MENU_API.EDUCATION_MATERIAL});
    this.setState({ 
      displayReminderSentList: false,
      displayFollowUpReminderList: false,
      displayActiveList: null, 
      selectedApi: MENU_API.EDUCATION_MATERIAL, 
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  false, 
      displayEducationMaterialCard : true, 
      displayWarningAdherenceCard : false, 
      displayNoReadingUploadedCard : false, 
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    })
  }
  toggleNoReadingUploadedCard(loadData = true){
    this.setQueryParams({tab : MENU_API.NO_READING_UPLOADED});
    this.setState({ 
      displayReminderSentList: false,
      displayFollowUpReminderList: false,
      displayActiveList: null, 
      selectedApi: MENU_API.NO_READING_UPLOADED, 
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  false, 
      displayEducationMaterialCard : false, 
      displayWarningAdherenceCard : false, 
      displayNoReadingUploadedCard : true, 
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    }, () => {
     if(loadData){
       this.fetchData();
     }
    })
  }
  toggleWarningAdherenceCard(loadData = true){
    this.setQueryParams({tab : MENU_API.WARNING_ADHERENCE});
    this.setState({ 
      displayReminderSentList: false,
      displayFollowUpReminderList: false,
      displayActiveList: null, 
      selectedApi: MENU_API.WARNING_ADHERENCE, 
      displayfollowUpPhoneCall : false, 
      displayMonthlyCheckInPhoneCall :  false, 
      displayEducationMaterialCard : false, 
      displayWarningAdherenceCard : true, 
      displayNoReadingUploadedCard : false, 
      displayHospitalAdmittedCard : false,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      displayNeedToFollowUpList: false,
      displayRpmCarePlanList: false,
      displayWinsPositiveOutcome: false,
    })
     if(loadData){
       this.fetchData();
     }
  }
  updateEducationCount(event){
  if(event){
    this.setState({educationPatientsCount : event})
  }
  }
  setQueryParams(newParams){
    const currentParams = queryString.parse(window.location.search);
    // Merge current and new query parameters
    const updatedParams = { ...currentParams, ...newParams };

    // Create the new query string
    const newQueryString = queryString.stringify(updatedParams);

    // Update the URL with new query params
    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?${newQueryString}`,
    });
  }
  componentDidMount() {
    const timeZone = moment.tz.guess();
    this.props.dispatch({
      type: "DO_GET_CREATE_PATIENT_PERMISSION"
    });
    this.props.dispatch({
      type: "GENERIC_ERROR"
    });
    this.props.dispatch({
      type: "DO_REMOVE_PROFILE_DATA"
    });
    this.props.dispatch({
      type: "DO_GET_ALL_PATIENT_COUNT",
      payload: {
        timeZone: timeZone || 'America/New_York'
      }
    });
    // this.props.dispatch({
    //   type: "DO_GET_USERS_YOU_HAVE_ACCESS"
    // });

    this.props.dispatch({
      type: "DO_GET_USERS_READING_UNDER_YOUR_ORGANIZATION"
    });
    this.props.dispatch({
      type: "DO_GET_PROFILE",
      payload: { authProfile: true }
    });
    const { tab } = queryString.parse(window.location.search);
    if(tab && tab == MENU_API.ACTIVE_PATIENT){
      this.toggleDisplayActiveList(true, false)
    }else if(tab && tab == MENU_API.IN_ACTIVE_PATIENT){
      this.toggleDisplayActiveList(false, false)
    }else if(tab && tab == MENU_API.ALL_PATIENT){
      this.toggleAllPatients(false)
    }else if(tab && tab == MENU_API.REMINDER_SENT){
      this.toggleRemindersSent(false)
    }else if(tab && tab == MENU_API.FOLLOW_UP_REMINDERS){
      this.toggleFollowUpReminders(false)
    }else if(tab && tab == MENU_API.FOLLOW_UP_PHONE_CALL){
      this.toggleFollowUpPhoneCallList(false)
    }else if(tab && tab == MENU_API.MONTHLY_CHECK_IN_PHONE_CALL){
      this.toggleMonthlyCheckInPhoneCallList(false)
    }else if(tab && tab == MENU_API.EDUCATION_MATERIAL){
      this.toggleEducationMaterialCard(false)
    }else if(tab && tab == MENU_API.WARNING_ADHERENCE){
      this.toggleWarningAdherenceCard(false)
    }else if(tab && tab == MENU_API.NO_READING_UPLOADED){
      this.toggleNoReadingUploadedCard(false)
    }else if(tab && tab == MENU_API.HOSPITAL_ADMISSION){
      this.toggleHospitalAdmittedPatientList(false)
    }else if(tab && tab == MENU_API.DEMO_PATIENT){
      this.toggleDemoList(false)
    }else if(tab && tab == MENU_API.CALLER_PATIENT){
      this.toggleCellularConnectivityList(false)
    }else if(tab && tab == MENU_API.NEED_TO_FOLLOW_UP){
      this.toggleNeedToFollowUpList(false)
    }else if(tab && tab == MENU_API.WINS_POSITIVE_OUTCOME){
      this.toggleWinsPositiveOutcomeList(false)
    }else if(tab && tab == MENU_API.RPM_CARE_PLAN){
      this.toggleRpmCarePlanList()
    }else{
      this.setQueryParams({tab : MENU_API.ACTIVE_PATIENT})
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.allPatientCount !== prevProps.allPatientCount) {
      this.setState({ loading: false });
    }
  }

  render() {
    //const removeNotApprove = _.orderBy(_.orderBy(this.props.assignedUsersList, 'isActive', 'desc'), 'fname', 'asc');
    const numberActive = this.props.allPatientCount ? this.props.allPatientCount.activePatients : 0;
    const numberInactive = this.props.allPatientCount ? this.props.allPatientCount.inActivePatients : 0;
    const numberDemo = this.props.allPatientCount ? this.props.allPatientCount.demoPatients : 0;
    const numberAllPatient = this.props.allPatientCount ? this.props.allPatientCount.allPatients : 0;
    const numberCellularConnectivity = this.props.allPatientCount ? this.props.allPatientCount.cellularConnectivityPatients : 0;
    const needToFollowUp = this.props.allPatientCount ? this.props.allPatientCount.needToFollowUp : 0;
    const followUpReminders = this.props.allPatientCount && this.props.allPatientCount.followUpReminders ? this.props.allPatientCount.followUpReminders : 0;
    const reminderSent = this.props.allPatientCount && this.props.allPatientCount.reminderSent ? this.props.allPatientCount.reminderSent : 0;
    const monthlyCheckInPhoneCall = this.props.allPatientCount && this.props.allPatientCount.monthlyCheckInPhoneCall ? this.props.allPatientCount.monthlyCheckInPhoneCall : 0;
    const followUpPhoneCall = this.props.allPatientCount && this.props.allPatientCount.followUpPhoneCall ? this.props.allPatientCount.followUpPhoneCall : 0;
    const educationMaterial = this.state.educationPatientsCount ? this.state.educationPatientsCount : this.props.allPatientCount && this.props.allPatientCount.educationMaterialPatients ? this.props.allPatientCount.educationMaterialPatients : 0;
    const warningAdherences = this.props.allPatientCount && this.props.allPatientCount.warningAdherences ? this.props.allPatientCount.warningAdherences : 0;
    const noReadingUploaded = this.props.allPatientCount && this.props.allPatientCount.noReadingUploaded ? this.props.allPatientCount.noReadingUploaded : 0;
    const hospitalAdminssionCount =  this.state.hospitalPatientsCount ? this.state.hospitalPatientsCount : this.props.allPatientCount && this.props.allPatientCount.hospitalAddmission
    const winsPositiveOutcome = this.props.allPatientCount ? this.props.allPatientCount.winsPositiveOutcome : 0;
    const rpmCarePlanCount = this.props.allPatientCount && this.props.allPatientCount.rpmCarePlanCount ? this.props.allPatientCount.rpmCarePlanCount : 0;
    const getActiveCardId = () => {
      // Check for All Patients first
      if (this.state.selectedApi === MENU_API.ALL_PATIENT) return 'all';
      if (this.state.displayActiveList === true) return 'active';
      if (this.state.displayActiveList === false) return 'inactive';
      if (this.state.displayDemoList) return 'demo';
      if (this.state.displayCellularConnectivityList) return 'cellular';
      if (this.state.displayNeedToFollowUpList) return 'followUp';
      if (this.state.displayHospitalAdmittedCard) return 'hospital';
      if (this.state.displayFollowUpReminderList) return 'followUpReminder';
      if (this.state.displayReminderSentList) return 'reminderSent';
      if (this.state.displayWarningAdherenceCard) return 'warning';
      if (this.state.displayfollowUpPhoneCall) return 'followUpPhone';
      if (this.state.displayMonthlyCheckInPhoneCall) return 'monthlyCheckIn';
      if (this.state.displayEducationMaterialCard) return 'education';
      if (this.state.displayWinsPositiveOutcome) return 'wins';
      if (this.state.displayNoReadingUploadedCard) return 'noReading';
      if (this.state.displayRpmCarePlanList) return 'rpmCarePlan';
      return null;
    };

    const activeCardId = getActiveCardId();

    // Dashboard cards configuration
    const cards = [
      { id: 'all', title: 'All', count: numberAllPatient, icon: 'mdi mdi-account-group', color: 'blue', onClick: () => this.toggleAllPatients() },
      { id: 'active', title: 'Active', count: numberActive, icon: 'mdi mdi-account-check', color: 'blue', onClick: () => this.toggleDisplayActiveList(true) },
      { id: 'inactive', title: 'Inactive', count: numberInactive, icon: 'mdi mdi-account-off', color: 'blue', onClick: () => this.toggleDisplayActiveList(false) },
      { id: 'followUp', title: 'Need To Follow Up', count: needToFollowUp, icon: 'mdi mdi-alert-circle', color: 'blue', onClick: () => this.toggleNeedToFollowUpList() },
      { id: 'hospital', title: 'Hospital Admission', count: hospitalAdminssionCount, icon: 'mdi mdi-hospital-building', color: 'blue', onClick: () => this.toggleHospitalAdmittedPatientList() },
      { id: 'followUpReminder', title: 'Follow Up Reminders', count: followUpReminders, icon: 'mdi mdi-bell', color: 'blue', onClick: () => this.toggleFollowUpReminders() },
      { id: 'followUpPhone', title: 'Follow Up Phone Call', count: followUpPhoneCall, icon: 'mdi mdi-phone', color: 'blue', onClick: () => this.toggleFollowUpPhoneCallList() },
      { id: 'monthlyCheckIn', title: 'Monthly Check in Phone Call', count: monthlyCheckInPhoneCall, icon: 'mdi mdi-phone-in-talk', color: 'blue', onClick: () => this.toggleMonthlyCheckInPhoneCallList() },
      { id: 'reminderSent', title: 'Reminder Sent', count: reminderSent, icon: 'mdi mdi-check-circle', color: 'blue', onClick: () => this.toggleRemindersSent() },
      { id: 'warning', title: 'Did Not Qualify Last Month', count: warningAdherences, icon: 'mdi mdi-close-circle', color: 'blue', onClick: () => this.toggleWarningAdherenceCard() },
      { id: 'education', title: 'Educational Material', count: educationMaterial, icon: 'mdi mdi-book-open-variant', color: 'blue', onClick: () => this.toggleEducationMaterialCard() },
      { id: 'noReading', title: 'No Reading Uploads (Past 6 Days)', count: noReadingUploaded, icon: 'mdi mdi-upload', color: 'blue', onClick: () => this.toggleNoReadingUploadedCard() },
      { id: 'wins', title: 'WINS - Positive Outcome', count: winsPositiveOutcome, icon: 'mdi mdi-trophy', color: 'blue', onClick: () => this.toggleWinsPositiveOutcomeList() },
      { id: 'rpmCarePlan', title: 'RPM Care Plan', count: rpmCarePlanCount, icon: 'mdi mdi-clipboard-text', color: 'blue', onClick: () => this.toggleRpmCarePlanList() },
    ];

    return (
      <div>
        <div className="row">
          <Heading
            title="PATIENTS"
            description=""
            toggleModal={this.toggleModal}
            backbutton="d-none"
            mainbutton="d-block"
            checkPermission = {this.props.checkPermission}
          >
            <span className="page-title-icon bg-gradient-danger   text-white mr-2">
              <i className="mdi mdi-account-convert" />
            </span>
          </Heading>

          <div className="col-12 grid-margin remove-pading-table">
            <div className="card">
              <div className="card-body project-tab pt-2">
                <Nav tabs className="justify-content-center">
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: this.state.activeTab === "1"
                      })}
                      onClick={() => {
                        this.toggle("1");
                      }}
                    >
                      <img className="img-tabsfluid mr-1" src={usersImage} />
                      PATIENTS
                    </NavLink>
                  </NavItem>
                </Nav>
                <Row>
                  <Col sm="12" className="grid-margin mt-4 remove-pading-table">
                    {this.state.loading && (
                      <ReactLoading className="mx-auto" color={"#007bff"} />
                    )}
                    {!this.state.loading && this.props.allPatientCount && (
                      <div> 
                        <div className="dashboard-container">
                          {cards.map((card) => (
                            <DashboardCard
                              key={card.id}
                              title={card.title}
                              count={card.count}
                              icon={card.icon}
                              color={card.color}
                              onClick={card.id === 'wins' ? () => this.toggleWinsPositiveOutcomeList() : card.onClick}
                              isActive={activeCardId === card.id}
                            />
                          ))}
                        </div>
                        {this.state.displayEducationMaterialCard ? (
                          <EducationMaterialSentPatients updateEducationCount={this.updateEducationCount}/>
                        ) : this.state.displayRpmCarePlanList ? (
                          <RpmCarePlanList />
                        ) : (
                          <ActivePatientList
                            fetchDataFromServer={(click) => (this.fetchData = click)}
                            selectedApi={this.state.selectedApi}
                            profileOwner={this.props.profileOwner}
                            readingSubTypes={this.props.readingSubTypes}
                            userId={this.props.userId}
                            deletePermission={this.deletePermission}
                            approvePermission={this.approvePermission}
                            receivedFrom={false}
                            displayActiveList={this.state.displayActiveList}
                            displayCellularConnectivityList={this.state.displayCellularConnectivityList}
                            displayNeedToFollowUpList={this.state.displayNeedToFollowUpList}
                            displayFollowUpReminderList={this.state.displayFollowUpReminderList}
                            displayReminderSentList={this.state.displayReminderSentList}
                            displayMonthlyCheckInPhoneCall={this.state.displayMonthlyCheckInPhoneCall}
                            displayfollowUpPhoneCall={this.state.displayfollowUpPhoneCall}
                            displayWarningAdherenceCard={this.state.displayWarningAdherenceCard}
                            displayHospitalAddmissionList={this.state.displayHospitalAdmittedCard}
                            displayWinsPositiveOutcome={this.state.displayWinsPositiveOutcome}
                            updateCount={this.updateCount}
                          />
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggleModal}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleModal}>
            Create a New Patient
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <h5 className="text-center" />
            <div className="row">
              {/* <div className="col-6">
                <NavLink
                  className="text-center d-block"
                  onClick={this.openInvite}
                >
                  <img
                    src="https://image.flaticon.com/icons/svg/201/201618.svg"
                    style={{ height: "180px" }}
                  />
                  <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                    INVITE A USER
                  </span>
                  <small>Send a sign up link</small>
                </NavLink>
              </div> */}
              <div className="col-6 mx-auto">
                <NavLink
                  className="text-center d-block"
                  onClick={this.toggleUserQuick}
                >
                  <img src={quickPatientImage} style={{ height: "180px" }} />
                  <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                    QUICK PATIENT CREATION
                  </span>
                  <small>You will input only essentials</small>
                </NavLink>
              </div>
              <div className="col-6 mx-auto">
                <NavLink
                  className="text-center d-block"
                  onClick={this.toggleUser}
                >
                  <img src={fullPatientImage} style={{ height: "180px" }} />
                  <span className="mt-2 menu-title font-weight-bold d-block text-dark">
                    FULL PATIENT CREATION
                  </span>
                  <small>You will input everything</small>
                </NavLink>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <SweetAlert
          success
          title="Success!"
          show={this.props.isGenericSuccess}
          onConfirm={this.resetForm}
          confirmBtnBsStyle="info"
        >
          {/* {!this.state.bday && (
            <div>
              Submitted Successfully Invitation is Sent to {this.state.email}
            </div>
          )} */}
          <div>User Created Successfully</div>
        </SweetAlert>
        <SweetAlert
          error
          title={this.props.genericErrorMessage.message}
          show={this.props.isGenericError}
          onConfirm={() => {
            this.props.dispatch({
              type: "GENERIC_ERROR"
            });
          }}
          confirmBtnBsStyle="danger"
          timeout={1000}
        >
          Error Code: {this.props.genericErrorMessage.error}
        </SweetAlert>
        <CreateUserModal
          modalUser={this.state.modalUser}
          toggleUser={this.toggleUser}
          errorPassword={this.state.errorPassword}
          submitUser={this.submitUser}
          handleInputChange={this.handleInputChange}
          handleInputChangeCondition={this.handleInputChangeCondition}
        />
        <CreateUserQuickModal
          modalQuickUser={this.state.modalQuickUser}
          toggleUserQuick={this.toggleUserQuick}
          errorPassword={this.state.errorPassword}
          submitUser={this.submitUser}
          handleInputChange={this.handleInputChange}
          handleInputChangeCondition={this.handleInputChangeCondition}
        />
      </div>
    );
  }
}
const mapStateToProps = ({ careprovider, user, auth }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    usersOfferedAccess,
    usersOfferedAccessOrganization,
    myAssignedCareProviders,
    allPatientCount,
    createPatientPermission
  } = careprovider;
  const { readingSubTypes } = auth;
  const userId = user.userDetails._id;
  const profileOwner = user.profileOwner;
  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    usersOfferedAccess,
    readingSubTypes,
    usersOfferedAccessOrganization,
    userId,
    profileOwner,
    myAssignedCareProviders,
    allPatientCount,
    createPatientPermission
  };
};

export default connect(mapStateToProps)(Analytics);
